// libs
import { create } from 'zustand';
// constants
import { INITIAL_STATE } from './constants';
const useConfigStore = create((set) => (Object.assign(Object.assign({}, structuredClone(INITIAL_STATE)), { setCities: (cities) => set({ cities }), setCampaignOpDisabled: (campaignOpDisabled) => set({ campaignOpDisabled }), setCampaignOpDisabledCallout: (campaignOpDisabledCallout) => set({ campaignOpDisabledCallout }) })));
export default useConfigStore;
